<template>
  <div class="nrbHero">
    <uhero
      :image="heroData.image"
      :title="heroData.title"
      :body="heroData.body"
    >
      <template v-slot:btn>
        <u-btn-outlined @click.prevent.native="Goto({name:'type_register', params: {type: 'nrb'}})">Join NRB Connect</u-btn-outlined>
      </template>
      <div class="container">
        <div class="workshop-hero-mobile">
          <div class="workshop_hero_content_mobile">
            <h3 class="workshop__text_mobile">
              {{ heroData.title }}
            </h3>
            <p class="workshop_desc_mobile">
              {{ heroData.body }}
            </p>
            <u-btn-outlined>Join NRB Connect</u-btn-outlined>
          </div>
        </div>
      </div>
    </uhero>
<!--    <section class="section">-->
<!--      <div class="container">-->
<!--        <div class="workshop-hero training-hero">-->
<!--          <img-->
<!--            src="../../assets/images/nrb-cover.png"-->
<!--            alt="Sign up as a trainer"-->
<!--            class="img-fluid"-->
<!--          />-->
<!--          <div class="workshop_hero_content">-->
<!--            <h3 class="workshop__text about_jumbo_title">-->
<!--              What is NRB connect?-->
<!--            </h3>-->
<!--            <p class="about_jumbo_desc">-->
<!--              NRB Connect is an initiative by Upskill to enable Non - Resident-->
<!--              Bangladeshis who are domain experts in particular fields to share-->
<!--              their knowledge with Local Talent.-->
<!--            </p>-->
<!--            <a href="#" class="btn btn-primary nrb_botton">Contact Us</a>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </section>-->
  </div>
</template>

<script>
export default {
  data() {
    return {
      heroData: {
        title: "What is NRB connect?",
        body:
          "NRB Connect is an initiative by Upskill to enable Non - Resident\n" +
          "              Bangladeshis who are domain experts in particular fields to share\n" +
          "              their knowledge with Local Talent.",
        image: require("../../assets/images/nrb-cover.png")
      }
    };
  }
};
</script>
